'use strict';

import GLightbox from 'glightbox'
import Component from "../../base/Component";

export default class Glightbox extends Component {
    constructor(props) {
        super(props);
    }

    init() {
        const lightbox = GLightbox({
            autoplayVideos: true,
            plyr: {
                config: {
                    autoplay: true,
                    controls: ['play-large', 'progress'],
                    // iconUrl: 'https://localhost:8080/spritemap.svg',
                    // iconPrefix: 'sprite'
                }
            }
        })
    }
}
